/* eslint-disable no-nested-ternary */
import React, { useState, useMemo } from 'react';
import { Grid, IconButton, CircularProgress } from '@material-ui/core';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import { DndContext, DragOverlay, rectIntersection } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import Card from '../CardDND';
import BoardContext from './context';

export default function Board({
  data,
  handleSaveProducts,
  saving = false,
  onEditProduct,
}) {
  const [lists, setLists] = useState(data);
  const [factor, setFactor] = useState(1);
  const [pendingStatus, setPendingStatus] = useState({});

  const effectiveStatus = useMemo(
    () => style_code =>
      pendingStatus[style_code] !== undefined
        ? pendingStatus[style_code]
        : lists.find(card => card.style_code === style_code)?.status,
    [lists, pendingStatus]
  );

  const handleToggleStatus = style_code => {
    setPendingStatus(prev => {
      const current = effectiveStatus(style_code);
      const next = current === 'Available' ? 'Cancelled' : 'Available';
      return { ...prev, [style_code]: next };
    });
  };

  const handleSave = () => {
    const merged = lists.map(card => ({
      ...card,
      status:
        pendingStatus[card.style_code] !== undefined
          ? pendingStatus[card.style_code]
          : card.status,
    }));
    handleSaveProducts(merged);
  };

  const handleFactor = num => {
    if (factor + num > 1) return;
    if (factor + num <= 0.2) return;
    setFactor(factor + num);
  };

  const [activeId, setActiveId] = useState(null);

  // Função para mover os itens
  const move = (from, to) => {
    setLists(prevCards => {
      const updatedCards = arrayMove(prevCards, from, to);
      return updatedCards;
    });
  };

  const handleDragStart = event => {
    setActiveId(event.active.id); // Armazena o ID do item ativo quando começa o arraste
  };

  const handleDragEnd = event => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const fromIndex = lists.findIndex(card => card._id === active.id);
    const toIndex = lists.findIndex(card => card._id === over.id);

    if (fromIndex === -1 || toIndex === -1) return;

    // Verifica se o item está majoritariamente sobre o outro (para troca de posição)
    const isOverlapping =
      event.over.rect.top < event.active.rect.current.translated.top + 20;

    setLists(prevLists => {
      const newList = [...prevLists];

      if (isOverlapping) {
        // Troca de posição
        return arrayMove(newList, fromIndex, toIndex);
      }
      // Insere antes do item sobreposto
      newList.splice(toIndex, 0, newList.splice(fromIndex, 1)[0]);
      return newList;
    });

    setActiveId(null);
  };

  return (
    <>
      <Grid style={{ position: 'fixed', right: 50, bottom: 20 }}>
        <Grid container>
          <IconButton onClick={() => handleFactor(-0.2)}>
            <ZoomOutIcon />
          </IconButton>
          <IconButton onClick={() => handleFactor(+0.2)}>
            <ZoomInIcon />
          </IconButton>
        </Grid>
        <button
          type="submit"
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: '8px 16px',
            background: saving ? '#555' : '#000',
            color: '#fff',
            border: 'none',
            cursor: saving ? 'wait' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            minWidth: 130,
            minHeight: 36,
          }}
        >
          {saving ? (
            <>
              <CircularProgress size={14} style={{ color: '#fff' }} />
              <span>Saving...</span>
            </>
          ) : (
            <span>Save changes</span>
          )}
        </button>
      </Grid>

      <BoardContext.Provider value={{ lists, move }}>
        <DndContext
          collisionDetection={rectIntersection}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {lists.map(card =>
              activeId === card._id ? null : (
                <Card
                  key={card._id}
                  id={card._id}
                  data={card}
                  factor={factor}
                  status={effectiveStatus(card.style_code)}
                  onToggleStatus={() => handleToggleStatus(card.style_code)}
                  onEditProduct={
                    onEditProduct
                      ? () => onEditProduct(card.style_code)
                      : undefined
                  }
                />
              )
            )}
          </div>

          <DragOverlay>
            {activeId ? (
              <Card
                id={activeId}
                data={lists.find(card => card._id === activeId)}
                factor={factor}
                status={effectiveStatus(
                  lists.find(card => card._id === activeId)?.style_code
                )}
                isDragging
              />
            ) : null}
          </DragOverlay>
        </DndContext>
      </BoardContext.Provider>
    </>
  );
}

// /* eslint-disable no-nested-ternary */
// import React, { useState } from 'react';

// import { Grid, IconButton } from '@material-ui/core';
// import ZoomOutIcon from '@material-ui/icons/ZoomOut';
// import ZoomInIcon from '@material-ui/icons/ZoomIn';
// import Card from '../CardDND';
// import BoardContext from './context';

// export default function Board({ data, handleSaveProducts }) {
//   const [lists, setLists] = useState(data);
//   const [factor, setFactor] = useState(1);

//   const handleFactor = num => {
//     if (factor + num > 1) return;
//     if (factor + num <= 0.2) return;
//     setFactor(factor + num);
//   };

//   function move(from, to) {
//     const newArr = lists.map((item, index) =>
//       index !== from && index !== to
//         ? item
//         : index === from
//         ? lists[to]
//         : lists[from]
//     );
//     setLists(newArr);
//   }

//   return (
//     <>
//       <Grid style={{ position: 'fixed', right: 50, bottom: 20 }}>
//         <Grid container>
//           <IconButton onClick={() => handleFactor(-0.2)}>
//             <ZoomOutIcon />
//           </IconButton>
//           <IconButton onClick={() => handleFactor(+0.2)}>
//             <ZoomInIcon />
//           </IconButton>
//         </Grid>
//         <button type="submit" onClick={() => handleSaveProducts(lists)}>
//           Save new order
//         </button>
//       </Grid>

//       <BoardContext.Provider value={{ lists, move }}>
//         {lists.map((card, index) => (
//           <Card key={card.id} index={index} data={card} factor={factor} />
//         ))}
//       </BoardContext.Provider>
//     </>
//   );
// }
